export default "__VITE_ASSET__db12ec16__"